import { render } from "./CompanyAdd.vue?vue&type=template&id=8d096da0"
import script from "./CompanyAdd.vue?vue&type=script&lang=js"
export * from "./CompanyAdd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__